export const PencilIcon = ({ width, height, ...props }) => (
  <svg
    width={width || 24}
    height={height || 24}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.45761 1.60421C8.58477 1.47705 8.73573 1.37618 8.90188 1.30736C9.06802 1.23855 9.24609 1.20313 9.42592 1.20312C9.60575 1.20312 9.78382 1.23855 9.94996 1.30736C10.1161 1.37618 10.2671 1.47705 10.3942 1.60421C10.5214 1.73137 10.6223 1.88233 10.6911 2.04847C10.7599 2.21462 10.7953 2.39269 10.7953 2.57252C10.7953 2.75235 10.7599 2.93042 10.6911 3.09656C10.6223 3.2627 10.5214 3.41366 10.3942 3.54082L3.85816 10.0769L1.19531 10.8031L1.92154 8.14028L8.45761 1.60421Z"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
